export default __webpack_public_path__ + "static/media/icons.152cd030.jpg";